import { Utils } from "@/core/utils.js";

export const UtilsPlugin = {
  install(Vue) {
    Vue.prototype.$utils = Utils(Vue.prototype);
  },
};
